import React from 'react'
import { Accordion, Box, Flex, Text, ActionIcon, Grid, Spoiler, Center } from '@mantine/core'
import classes from './DetailSlug.module.css'

const CurriculumSection = ({ curriculums }) => {

  // eslint-disable-next-line
  const mappingVisibleCurriculum = (data) => data.map((val, index) => {
    const innerHtml = { __html: val.description }
    if (index < 4) {
      return (
        <Grid.Col span={{ base: 12, lg: 6 }}>
          <Accordion.Item className={classes.itemCurriculum} value={val.id} key={val.name} style={{ cursor: 'pointer', border: '0.125rem solid #dee2e6', borderRadius: '10px', zIndex: 0 }}>
            <Accordion.Control>
              <Flex wrap='noWrap' gap='md' align='center'>
                <ActionIcon color='#043056' radius="xl" size='md' variant="filled">
                  <Text fz={12} fw="bold" pt={2}>{index + 1}</Text>
                </ActionIcon>
                <Center h={50}>
                  <Text fz={14} fw="bold" lineClamp={2}>{val.name}</Text>
                </Center>
              </Flex>
            </Accordion.Control>
            <Accordion.Panel px={10}>
              <Box>
                <Text fz={13} fw='600' mt={0} dangerouslySetInnerHTML={innerHtml} />
              </Box>
            </Accordion.Panel>
          </Accordion.Item>
        </Grid.Col>
      )
    }
  })

  // eslint-disable-next-line
  const mappingHiddenCurriculum = (data) => data.map((val, index) => {
    const innerHtml = { __html: val.description }
    if (index > 3) {
      return (
        <Grid.Col span={{ base: 12, lg: 6 }}>
          <Accordion.Item className={classes.itemCurriculum} value={val.id} key={val.name} style={{ cursor: 'pointer', border: '0.125rem solid #dee2e6', borderRadius: '10px', zIndex: 0 }}>
            <Accordion.Control>
              <Flex wrap='noWrap' gap='md' align='center'>
                <ActionIcon color='#043056' radius="xl" size='md' variant="filled">
                  <Text fz={12} fw="bold" pt={2}>{index + 1}</Text>
                </ActionIcon>
                <Center h={50}>
                  <Text fz={14} fw="bold" lineClamp={2}>{val.name}</Text>
                </Center>
              </Flex>
            </Accordion.Control>
            <Accordion.Panel px={10}>
              <Box>
                <Text fz={13} fw='600' mt={0} dangerouslySetInnerHTML={innerHtml} />
              </Box>
            </Accordion.Panel>
          </Accordion.Item>
        </Grid.Col>
      )
    }
  })

  const mappingDataCurriculum = (dataCurriculum) => {
    const showMoreButton = () => {
      return (
        <Box style={{ display: 'block', cursor: 'pointer', width: '140px', height: '30px' }}>
          <Text fz={12} fw='500'>Lihat Lebih Banyak</Text>
        </Box>
      )
    }

    const hideButton = () => {
      return (
        <Box style={{ display: 'block', cursor: 'pointer', width: '140px', height: '30px' }}>
          <Text fz={12} fw='500'>Lihat Lebih Sedikit</Text>
        </Box>
      )
    }

    return (
      <Accordion variant='separated'>
        <Box>
          <Grid align="flex-start">
            {mappingVisibleCurriculum(curriculums)}
            <Spoiler px={8} maxHeight={0} showLabel={showMoreButton()} hideLabel={hideButton()}>
              <Grid align="flex-start" py={8}>{mappingHiddenCurriculum(curriculums)}</Grid>
            </Spoiler>
          </Grid>
        </Box>
      </Accordion>
    )
  }
  return (
    <Box mb={70}>
      <Text fz="md" fw="bold">Materi</Text>
      <Box mt="md" w='auto'>
        {curriculums.length > 0 ? mappingDataCurriculum(curriculums) : (<Text fz="md" fw="bold">Event ini belum memiliki kurikulum</Text>)}
      </Box>
    </Box>
  )
}

export default CurriculumSection 